// @ts-nocheck

import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import styled, { css } from 'styled-components';

import { Target } from '../../client';
import { RedirectServices, getRedirectUrl } from '../../config/urls';
import useRouter from '../../hooks/useRouter';
import { handleInternalNavigation } from '../../utils/notification';

const Wrapper = styled.div`
  padding: ${Target.__MOBILE__ ? '0em 0.7em 0.7em' : '10px'};
`;

const ClickableArea = styled.div`
  ${({ onClick }) =>
    !Target.__MOBILE__ && !!onClick
      ? css`
          cursor: pointer;
        `
      : undefined}
`;

const Image = styled.img`
  display: block;
  width: 100%;
  height: auto;
  border-radius: 0.5em;
`;

type MatchPromoCardProps = {
  className?: string;
  promotionImage: string;
  promotionUrl: string | null;
  promotionWamUrl: string | null;
  openExternalLink: (...params: unknown) => unknown;
};

const MatchPromoCard = ({
  className,
  promotionImage,
  promotionUrl,
  promotionWamUrl,
  openExternalLink,
}: MatchPromoCardProps) => {
  const { history } = useRouter();
  const dispatch = useDispatch();
  const onClick = useCallback(() => {
    if (promotionWamUrl) {
      handleInternalNavigation({ history, dispatch, uri: promotionWamUrl });
    } else if (promotionUrl) {
      const url = getRedirectUrl(RedirectServices.ENCODED_URL, { url: promotionUrl });
      openExternalLink(url, { auth: true });
    }
  }, [promotionWamUrl, history, dispatch, openExternalLink, promotionUrl]);
  return (
    <Wrapper className={className}>
      <ClickableArea onClick={promotionUrl ? onClick : null}>
        <Image src={promotionImage} />
      </ClickableArea>
    </Wrapper>
  );
};

export default React.memo<MatchPromoCardProps>(MatchPromoCard);
